import { useState } from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as yup from "yup";
import { updatePasswordUtilisateur } from "../../services/utilisateurs/UtilisateursRequest";
import { Oval } from "react-loader-spinner";
import { useTranslation } from "react-i18next";

function UpdatePasswordUtilisateur(props) {
  const { t } = useTranslation();
  const [messageError, setMessageError] = useState("");
  const [loading, setloading] = useState(false);

  let initialValues = {
    login: props.data.id !== undefined ? props.data.id : "desire.nda",
    ancienmotdepasse: "",
    password: "",
  };

  const validationValuesSchema = yup.object().shape({
    ancienmotdepasse: yup
      .string()
      .required(t('users.updatePassword.errors.oldPasswordRequired')),
    password: yup
      .string()
      .required(t('users.updatePassword.errors.newPasswordRequired')),
  });

  //Enregistrement de l'utilisateur
  const handleOnSubmitPassword = (values) => {
    setloading(true);
    console.log(values);
    updatePasswordUtilisateur(values)
      .then((res) => {
        setloading(false);
        props.afficherListeUtilisateur(1);
        props.setPageActive(1);
        document.getElementById("closePasswordProfil").click();
      })
      .catch((err) => {
        setloading(false);
        console.log(err.response.data);
      });
  };

  return (
    <div
      className="modal fade"
      id="updatePasswordUtilisateur"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex={-1}
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content blueSkanpay">
          <div className="modal-header text-white">
            <h5 className="modal-title" id="staticBackdropLabel">
              {t('users.updatePassword.title')}
            </h5>
            <button
              type="button"
              className="bg-danger btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body bg-white">
            <Formik
              initialValues={initialValues}
              enableReinitialize
              validationSchema={validationValuesSchema}
              onSubmit={handleOnSubmitPassword}
            >
              {({ resetForm }) => (
                <Form>
                  {messageError !== "" && (
                    <p className="text-danger">
                      <i className="fa fa-exclamation-triangle"></i>{" "}
                      {messageError}
                    </p>
                  )}
                  <div className="mb-3">
                    <label htmlFor="login" className="form-label">
                      {t('users.updatePassword.login')}
                    </label>
                    <Field
                      type="text"
                      name="login"
                      className="form-control"
                      id="login"
                      disabled
                    />
                    <p className="text-danger">
                      <ErrorMessage name="login"></ErrorMessage>
                    </p>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="ancienmotdepasse" className="form-label">
                      {t('users.updatePassword.oldPassword')}
                    </label>
                    <Field
                      type="password"
                      name="ancienmotdepasse"
                      className="form-control"
                      id="ancienmotdepasse"
                    />
                    <p className="text-danger">
                      <ErrorMessage name="ancienmotdepasse"></ErrorMessage>
                    </p>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="password" className="form-label">
                      {t('users.updatePassword.newPassword')}
                    </label>
                    <Field
                      type="password"
                      name="password"
                      className="form-control"
                      id="password"
                    />
                    <p className="text-danger">
                      <ErrorMessage name="password"></ErrorMessage>
                    </p>
                  </div>
                  <div className="modal-footer bg-white">
                    <button
                      id="closePasswordProfil"
                      type="button"
                      onClick={() => {
                        resetForm();
                        setMessageError("");
                      }}
                      className="btn btn-sm btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      {t('users.updatePassword.close')}
                    </button>
                    <Oval
                      width={30}
                      height={30}
                      color="#344b7b"
                      visible={loading}
                    />
                    {!loading && (
                      <button type="submit" className="btn btn-sm btn-primary">
                        {t('users.updatePassword.confirm')}
                      </button>
                    )}
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpdatePasswordUtilisateur;
